export default __webpack_public_path__ + "static/media/black-penguin.65b79263.svg";